// Generic slug/code helpers shared by KPI definitions and report fields.
// A "code" is a snake_case identifier with a per-system UNIQUE constraint, so
// the generator both normalizes input AND deduplicates against codes already
// taken (appending _2, _3, …).

export function slugify(text) {
  return String(text ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

export function dedupeCode(baseCode, existingCodes) {
  const taken = new Set(existingCodes);
  if (!baseCode || !taken.has(baseCode)) return baseCode;
  let n = 2;
  while (taken.has(`${baseCode}_${n}`)) n++;
  return `${baseCode}_${n}`;
}
